const HomeSectionData = {
  alt: "my portrait",
  title: "Greetings,",
  subTitle: "a bit about me:",
  resume: "MY RESUME",
  work: "MY WORK",
  skills: "MY SKILLS",
  presentation: "I am a hard worker, fast learner,  and self-motivated person, seeking a Frontend Web Development contract position that will benefit from my technical skills developed through past work experiences. I exercise patience when needed and I am very open to learning new things. "
};

export default HomeSectionData;